import moment from 'moment'
import {Button, Card, Col, Form, InputGroup, Row, Spinner} from 'react-bootstrap'

export const LoadingAllValidations = () => {
  return (
    <div>
      <Card>
        <Card.Header>
          <Card.Title>Validaciones</Card.Title>
          <div className='card-title'>
            <Button size='sm' disabled>
              <i className='bi bi-plus' style={{color: 'inherit'}} /> Agregar
            </Button>
          </div>
        </Card.Header>
        <Card.Body>
          <Row className='my-3 gap-x-2'>
            <Col sm={12} md={4} lg={5}>
              <form>
                <InputGroup className='mb-3'>
                  <Form.Control
                    type='search'
                    placeholder='Nombre o No. documento'
                    aria-label='Buscar'
                    aria-describedby='basic-addon2'
                    readOnly
                  />
                  <Button type='submit' variant='secondary' id='button-addon2'>
                    <i className='bi bi-search fs-2' />
                  </Button>
                </InputGroup>
              </form>
            </Col>
            <Col sm={12} md={8} lg={7}>
              <Row className='gap-md-0 gap-2'>
                <Col sm={12} md={6}>
                  <Form.Select aria-label='Default select example' disabled>
                    <option value=''>Estado</option>
                    {['CREADA', 'EN_PROCESO', 'EXITOSA', 'RECHAZADA', 'ANULADA'].map((st) => (
                      <option key={st} value={st}>
                        {st.replace('_', ' ')}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col sm={12} md={6}>
                  <Button
                    id='buttonId'
                    data-tooltip-id='buttonId'
                    variant='outline'
                    className='h-100 w-100'
                    disabled
                    style={{
                      fontSize: '13px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {moment(new Date()).format('DD/MM/YYYY')} -{' '}
                    {moment(new Date()).format('DD/MM/YYYY')}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <div className='d-flex flex-center' style={{minHeight: '30vh'}}>
            <Spinner animation='border' />
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}
